/** Order type strings used throughout the cashier checkout flow. */
export const ORDER_TYPE = {
  EDIT_ORDER: "edit-order",
  EDIT_SALES: "edit-sales",
  NEW_ORDER: "new-order",
  SPLIT_PAY: "split-pay",
} as const;

export type OrderTypeValue = (typeof ORDER_TYPE)[keyof typeof ORDER_TYPE];
